import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { BrowserRouter, Route, Switch, Link, Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { Button, Grid, Row, Col } from 'react-bootstrap';

// Helpers de formulário
import RequestApi from './RequestApi';


class BotaoFinalizarProva extends Component {

  // constructor
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <button onClick={() => self.props.finalizarProva()} className="btn btn-block">FINALIZAR PROVA</button>
      </div>
    );
  }
}

export default BotaoFinalizarProva;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/BotaoFinalizarProva.js